/**
 * Render a free-text note comment as safe HTML, for NoteText.vue to parse.
 *
 * Notes can include light structural HTML (Vern wraps lines in `<p>`, others use
 * `<br>`) plus HTML entities (`&nbsp;`, `&amp;`, numeric refs like `&#039;`).
 *
 * Strategy: escape `<` and `>` only — which neutralises ALL tags and attributes
 * — then restore the few safe structural tags (`<p>`, `</p>`, `<br>`). `&` is
 * deliberately left unescaped so existing entities decode in the browser; with
 * angle brackets gone, a stray `&` can't be used to inject a tag or attribute.
 *
 * Everything else (script/img/onerror, and even `<p onclick=…>` — note the
 * restore only revives the BARE tags) stays escaped and renders as inert text.
 *
 * @param {string|null|undefined} raw
 * @returns {string} sanitised HTML
 */
export function sanitiseNoteComment(raw) {
    const escaped = (raw ?? '').replace(/</g, '&lt;').replace(/>/g, '&gt;');

    return escaped
        .replace(/&lt;p&gt;/gi, '<p>')
        .replace(/&lt;\/p&gt;/gi, '</p>')
        .replace(/&lt;br\s*\/?&gt;/gi, '<br>');
}
